<template>
  <div class="common-title-page analyse-runs">
    <div class="title-wrapper">
      <span class="title">{{
        $t('text.product_characterisation_analysis')
      }}</span>
      <div class="text-right">
        <UtcOffsets />
      </div>
    </div>
    <div class="max-w-800" style="margin: 20px auto">
      <div>
        <span class="mr-15">{{ $t('text.run') }}</span>
        <b-button
          size="sm"
          variant="outline-success"
          @click="select()"
          class="min-w-80"
          >{{ $t('text.select') }}</b-button
        >
        <b-button
          size="sm"
          variant="outline-primary"
          class="min-w-80 right-float"
          >{{ $t('text.export_data') }}</b-button
        >
      </div>
      <div v-loading="loading || detailsLoading">
        <el-table border :data="tableData" size="mini" class="mt-20">
          <el-table-column label="ID" prop="id" width="50px"> </el-table-column>
          <el-table-column :label="$t('text.date')" width="150px">
            <template slot-scope="scope">
              {{
                moment
                  .utc(scope.row.startTime)
                  .tz($store.state.pods.selectedUtcOffset)
                  .format('DD/MM/YY @ h:mm a')
              }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('text.tester')"
            prop="doneBy"
            width="150px"
          >
          </el-table-column>
          <el-table-column :label="$t('text.pod')" prop="podMac">
          </el-table-column>
          <el-table-column :label="$t('text.position')" prop="position">
          </el-table-column>
          <el-table-column
            :label="$t('text.weight') + '(Kg)'"
            prop="comments"
            width="100px"
          >
          </el-table-column>
        </el-table>
        <el-table :data="comments" border size="mini" class="mt-20">
          <el-table-column :label="$t('text.comments_for') + ' ' + id">
            <el-table-column :label="$t('text.time')">
              <template slot-scope="scope">
                {{
                  moment
                    .utc(scope.row.commentTime)
                    .tz($store.state.pods.selectedUtcOffset)
                    .format('DD/MM/YY @ h:mm a')
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="comment"
              :label="$t('text.comment')"
            ></el-table-column>
          </el-table-column>
        </el-table>
        <el-table :data="details" border size="mini" class="mt-20">
          <el-table-column
            :label="$t('text.pad_characterization_detail_for') + ' ' + id"
          >
            <el-table-column
              prop="pour"
              :label="$t('text.desc')"
            ></el-table-column>
            <el-table-column :label="$t('text.time')">
              <template slot-scope="scope">
                {{
                  moment
                    .utc(scope.row.time)
                    .tz($store.state.pods.selectedUtcOffset)
                    .format('DD/MM/YY @ h:mm a')
                }}
              </template></el-table-column
            >
            <el-table-column
              prop="median"
              :label="$t('text.median') + '(' + $t('text.sensor') + ')'"
            ></el-table-column>
            <el-table-column
              prop="sum"
              :label="$t('text.median') + '(' + $t('text.agg') + ')'"
            ></el-table-column>
            <el-table-column
              prop="volume"
              :label="$t('text.volume')"
            ></el-table-column>
          </el-table-column>
        </el-table>
        <div class="chart-wrapper">
          <div
            class="mt-20"
            id="echarts"
            :style="{
              width: '100%',
              height: '400px'
            }"
          ></div>
          <TagBox
            ref="tagBox"
            :fromDate="fromDate"
            :toDate="toDate"
            :podMac="tableData[0].podMac"
            :utcOffset="$store.state.pods.selectedUtcOffset"
            @savedSuccess="handleAfterSavedTag()"
            v-if="showTagBox"
          />
        </div>
      </div>
    </div>
    <SelectRunInAnalyse ref="selectRunInAnalyse" />
  </div>
</template>

<script>
import moment from 'moment'
import CommonApiService from '@/services/CommonApiService.js'
import SelectRunInAnalyse from '@/components/products/characterisation/SelectRunInAnalyse'
import TagBox from '@/components/TagBox'
import UtcOffsets from '@/components/UtcOffsets'
export default {
  data() {
    return {
      moment,
      loading: false,
      detailsLoading: false,
      id: '',
      tableData: [],
      comments: [],
      details: [],
      chart: '',
      fromDate: '',
      toDate: '',
      showTagBox: false,
      source: [
        [
          'timeValue',
          'sensor1Value',
          'sensor2Value',
          'sensorValue',
          'timeStamp'
        ],
        ['', 0, 0, 0, '']
      ]
    }
  },
  components: {
    SelectRunInAnalyse,
    TagBox,
    UtcOffsets
  },
  mounted() {
    this.initChart()
  },
  watch: {
    '$store.state.locale.currentLocale': function() {
      this.getDetails()
    },
    id() {
      this.chart.clear()
      this.comments = []
      this.details = []
      this.getComments()
      this.getDetails()
    },
    '$store.state.pods.selectedUtcOffset': function() {
      //if user change utc offset, change all date shown in the page
      this.calculateChartSourceWithUtc()
      this.initChart()
    }
  },
  methods: {
    select() {
      this.$refs.selectRunInAnalyse.openDialog()
    },
    getComments() {
      if (!this.id) return false
      this.loading = true
      CommonApiService.GetPadCharacterizationCommentById(this.id)
        .then(response => {
          this.loading = false
          this.comments = response.data.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    getDetails() {
      if (!this.id) return false
      this.detailsLoading = true
      CommonApiService.GetCharacterizationDetail(this.id)
        .then(response => {
          this.detailsLoading = false
          this.details = response.data.data.medianRecords

          this.source = [
            [
              'timeValue',
              'sensor1Value',
              'sensor2Value',
              'sensorValue',
              'timeStamp'
            ]
          ]
          let vm = this
          response.data.data.records.forEach(item => {
            vm.source.push([
              '',
              item.sensor1Value,
              item.sensor2Value,
              item.sensorValue,
              moment(item.timeStamp).format('YYYY-MM-DD HH:mm:ss')
            ])
          })
          if (this.source.length <= 1) {
            this.source.push(['', 0, 0, 0, ''])
          }
          this.calculateChartSourceWithUtc()
          this.initChart()
        })
        .catch(() => {
          this.detailsLoading = false
          this.initChart()
        })
    },
    initChart() {
      let vm = this
      var dom = document.getElementById('echarts')
      this.chart = this.echarts.init(dom)
      this.chart.setOption({
        grid: {
          left: 10,
          right: 30,
          bottom: 50,
          top: 20,
          containLabel: true
        },
        toolbox: {
          show: this.source[1] && this.source[1][0],
          feature: {
            brush: {
              title: {
                lineX: this.$t('text.select'),
                clear: this.$t('text.clear_selected')
              }
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter(params) {
            let tooltipStr = `<div>${moment(params[0].axisValue).format(
              'DD/MM/YY HH:mm:ss'
            )}</div>`
            params.forEach(item => {
              if (tooltipStr.indexOf(item.color) < 0) {
                tooltipStr =
                  tooltipStr +
                  `<div><div style="display:inline-block; margin-right: 5px; width: 10px; height: 10px; border-radius: 5px; background-color:${
                    item.color
                  }"></div>${item.seriesName} : ${
                    item.value[item.seriesIndex + 1]
                  }</div>`
              }
            })
            return tooltipStr
          }
        },
        color: ['#008ffb', '#00e396', '#feb019'],
        legend: {
          x: 'center',
          y: 'bottom',
          data: [
            this.$t('text.sensor') + '1',
            this.$t('text.sensor') + '2',
            this.$t('text.sensor_value')
          ]
        },
        xAxis: [
          {
            type: 'time',
            boundaryGap: false,
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              showMinLabel: true,
              showMaxLabel: true,
              formatter: function(value) {
                let time = value ? moment(value) : ''
                return time.format('HH:mm:ss') + '\n' + time.format('DD/MM/YY')
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            nameLocation: 'center',
            nameGap: 40,
            axisLine: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#f2f2f2'],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        dataZoom: [
          {
            show: true,
            height: 25,
            bottom: 25,
            start: 0,
            zoomOnMouseWheel: true,
            moveOnMouseMove: true
          },
          {
            type: 'inside'
          }
        ],
        dataset: {
          dimensions: [
            'timeValue',
            'sensor1Value',
            'sensor2Value',
            'sensorValue',
            'timeStamp'
          ],
          source: this.source
        },
        series: [
          {
            name: this.$t('text.sensor') + '1',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeValue',
              y: 'sensor1Value'
            }
          },
          {
            name: this.$t('text.sensor') + '2',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeValue',
              y: 'sensor2Value'
            }
          },
          {
            name: this.$t('text.sensor_value'),
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeValue',
              y: 'sensorValue'
            }
          }
        ],
        brush: {
          toolbox: ['lineX', 'clear'],
          xAxisIndex: 0,
          throttleType: 'debounce',
          throttleDelay: 200,
          brushStyle: {
            borderWidth: 2,
            color: 'rgba(255, 255, 0, 0.15)',
            borderColor: '#ec808d'
          }
        }
      })
      this.chart.off('brushSelected')
      this.chart.on('brushSelected', this.brushSelected)
      this.chart.on('brushEnd', this.brushEnd)
      window.addEventListener('resize', function() {
        vm.chart.resize()
      })
    },
    brushSelected(params) {
      if (this.showTagBox && !params.batch[0].areas.length) {
        this.clearTagForm()
      }
    },
    clearTagForm() {
      this.showTagBox = false
      this.$refs.tagBox.$refs.tagForm.resetFields()
      this.$refs.tagBox.tagDataForm = {
        tag: [],
        notes: ''
      }
      this.fromDate = this.toDate = ''
    },
    brushEnd(params) {
      this.showTagBox = true

      //Gets the index of the selected region
      let tagSelectedArea = params.areas[0].range
      let seleted = this.chart._chartsViews[0]._points
        .map(([left], i) => {
          return left >= tagSelectedArea[0] && left <= tagSelectedArea[1]
            ? i
            : -1
        })
        .filter(item => {
          return item >= 0
        })

      //Gets the data for the visual region after scaling
      let shownSource = []
      let rangeStart = this.chart.getModel().option.xAxis[0].rangeStart
      let rangeEnd = this.chart.getModel().option.xAxis[0].rangeEnd
      this.source.forEach((item, index) => {
        if (index > 0) {
          if (rangeStart && rangeEnd) {
            if (
              moment(item[0]).valueOf() >= rangeStart &&
              moment(item[0]).valueOf() <= rangeEnd
            ) {
              shownSource.push(item)
            }
          } else {
            shownSource.push(item)
          }
        }
      })

      this.fromDate = shownSource[seleted[0]][4]
      this.toDate = shownSource[seleted[seleted.length - 1]][4]
    },
    handleAfterSavedTag() {
      this.clearTagForm()
      this.chart.dispatchAction({
        type: 'brush',
        areas: []
      })
    },
    calculateChartSourceWithUtc() {
      let vm = this
      this.source = this.source.map((item, index) => {
        let obj = item
        if (index > 0) {
          obj[0] = moment
            .utc(item[4])
            .tz(vm.$store.state.pods.selectedUtcOffset)
            .format('YYYY-MM-DD HH:mm:ss')
        }
        return obj
      })
      this.source.sort(function(x, y) {
        return moment(x[0]) - moment(y[0])
      })
    }
  }
}
</script>
